import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import { SxProp } from '@hrlogics/react-helper-types';

type ApproveOrDeclineVerificationRequestModalContentProps = {
  action: 'approve' | 'decline';
  onCloseModal: () => void;
  handleAction: () => Promise<void> | void;
  disabled?: boolean;
  loading?: boolean;
};

export const ApproveOrDeclineVerificationRequestModalContent: React.FC<
  ApproveOrDeclineVerificationRequestModalContentProps
> = ({ onCloseModal, handleAction, action, disabled, loading }) => {
  return (
    <React.Fragment>
      <Typography variant="h2" sx={titleStyles}>
        Are you sure?
      </Typography>

      <Typography variant="body1" mt={2} data-e2e-element="confirmation-modal-text">
        Confirm you want to {action} this request
      </Typography>

      <Box display="flex" gap={3} mt={3} justifyContent="center" alignItems="center">
        <Button color="primary" variant="outlined" onClick={onCloseModal} disabled={disabled}>
          Cancel
        </Button>
        <Button
          color={action === 'decline' ? 'error' : 'primary'}
          variant="contained"
          onClick={handleAction}
          disabled={disabled}
          loading={loading}
          data-e2e-element="confirm-button"
        >
          Yes, {action}
        </Button>
      </Box>
    </React.Fragment>
  );
};

const titleStyles: SxProp = {
  fontSize: '24px',
};
